"use client";

import { useContext } from "react";
import { AppSettingsContext, AppSettingsContextValue } from "@/app";

export const useAppSettings = (): AppSettingsContextValue => {
  const context = useContext(AppSettingsContext);
  if (!context) {
    throw new Error(
      "useAppSettings must be used within an AppSettingsProvider"
    );
  }
  return context;
};
